import React from 'react';
import {DEFAULT_PRIMARY_COLOR} from '../../../data/staticValues/colors';

interface Props {
  answer: string;
  selected: boolean;
  onClick: (answer: string) => void;
  disabled?: boolean;
}

const AnswerCircle = React.memo(
  ({answer, selected, onClick, disabled}: Props) => {
    const primaryColor =
      typeof window !== 'undefined'
        ? localStorage.getItem('primaryColor') || DEFAULT_PRIMARY_COLOR
        : DEFAULT_PRIMARY_COLOR;
    return (
      <div
        role="radio"
        aria-checked={selected}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        onClick={() => !disabled && onClick(answer)}
        onKeyDown={event => {
          if (!disabled && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            onClick(answer);
          }
        }}
        className="AnswerCircle">
        <div className="Checkbox">
          {selected ? (
            <div className="Checked" style={{backgroundColor: primaryColor}} />
          ) : (
            <div />
          )}
        </div>
        <span>{answer}</span>
      </div>
    );
  },
);

export default AnswerCircle;
